import type { BatchListItemVM } from "@shared-kernel/application/ports/educational-advisor/educational-advisor-repository";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

export const retrieveEducationalAdvisorBatches = createApiThunk<BatchListItemVM[], void>(
  "educationalAdvisor/retrieveBatches",
  async (_, { extra: { educationalAdvisorRepository } }) => {
    return educationalAdvisorRepository!.batchList();
  },
);
